import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImageSelectionService {
  private imageOptionsSubject = new BehaviorSubject<string[] | null>(null); 
  public imageOptions$ = this.imageOptionsSubject.asObservable();
  
  private imageUrlsSource = new BehaviorSubject<string[] | null>(null);
  public imageUrls$ = this.imageUrlsSource.asObservable();

  updateImageUrls(urls: string[]) {
    this.imageUrlsSource.next(urls);
  }

  resetImageUrls() {
    this.imageUrlsSource.next(null); 
  }

  updateImageOptions(imageOptions: string[]): void {
    this.imageOptionsSubject.next(imageOptions);
  }

  resetImageOptions(): void {
    this.imageOptionsSubject.next(null); 
  }
}

